// extracted by mini-css-extract-plugin
module.exports = {"shadow":"TradePricedToday_shadow__2k5sw","tradePricedTodayWrapper":"TradePricedToday_tradePricedTodayWrapper__1wQLr"};